// Helper fire-and-forget per notificare al sender che il recipient ha
// cambiato stato (accept / complete / delete) sulla propria copia del
// task condiviso. Usato dai store (taskStore.toggleTask, taskStore.deleteTask,
// authStore.acceptShare).
//
// Non blocca il flusso del chiamante: errori vengono solo loggati. La
// riconciliazione real-time della UI del sender è garantita dal trigger DB
// `sync_shared_task_status` + Realtime su `shared_tasks` (canale
// `store-shares:<senderId>`); questa notifica è solo un "wake-up" per
// raggiungerlo anche quando l'app non è in foreground.
import { getSessionSafe } from './supabase'

export async function notifyShareUpdate(shareId, action) {
  if (!shareId || !action) return
  try {
    const session = await getSessionSafe()
    if (!session?.access_token) return
    await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/notify-share-update`, {
      method: 'POST',
      headers: {
        'Content-Type':  'application/json',
        'Authorization': `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({ shareId, action }),
    })
  } catch (err) {
    console.warn('[notifyShareUpdate]', action, err?.message)
  }
}
